import { Skeleton } from './skeleton';
import { reportCard } from '../report/styles';
import { cn } from '../../utils';

interface ChartSkeletonProps {
  /** Fixed height in px — pass the SAME height the real chart container
   *  uses so the swap is zero-shift (e.g. `HomeScoreTrend`'s 280px canvas). */
  height?: number;
  className?: string;
}

/**
 * ChartSkeleton — fixed-height placeholder matching a chart's container.
 * Renders a flat baseline + a faint rising bar silhouette so it reads as
 * "a chart is coming" rather than a generic gray box. Use for any
 * `isLoading` chart surface (trend lines, composition bars) — never a bare
 * `<Skeleton className="h-64 w-full" />`.
 */
export function ChartSkeleton({ height = 240, className }: ChartSkeletonProps) {
  return (
    <div
      className={cn('flex w-full items-end gap-2 p-3.5', reportCard.section, className)}
      style={{ height }}
      aria-hidden="true"
    >
      {[40, 65, 45, 80, 55, 90, 60, 75, 50, 85, 65, 95].map((h, i) => (
        <Skeleton key={i} className="flex-1 rounded-t-sm rounded-b-none" style={{ height: `${h}%` }} />
      ))}
    </div>
  );
}
